<template>
    <section class="hero-branding bg-cover" :style="bgImg" id="home">
        <div class="container-fluid container-fluid--cp-150">
            <div class="row">
                <div class="col-md-6">
                    <div class="hero-content">
                        <h2 class="h1 hero-content-title text-black">{{ $t('title') }}</h2>
                        <h6 class="hero-content-subtitle text-black mt-20">{{ $t('subtitle') }}</h6>
                        <h6 class="hero-content-subtitle text-black mt-20"><b>{{ $t('soon') }}</b></h6>
                        <div class="slider-button mt-30">
                            <router-link :to="{ path: '/contact' }" class="btn btn--gradient"> 
                                <i class="fa fa-bell"></i>
                                 {{ $t('getNotified') }} 
                                <i class="fas fa-bell"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data (){
            return {
                bgImg: {
                    backgroundImage: `url(${require('../assets/img/hero/app-landing/app-landing.png')})`
                },
            }
        }
    }
</script>

<i18n>
{
  "en": {
    "title": "Manage your IBS Today!",
    "subtitle": "Manage your IBS, triggers and lifestyle, with an IBS tracker app made by people with IBS for people with IBS.",
    "soon": "Soon on iPhone and Android.",
    "getNotified": "Get Notified"
  },
  "fr": {
    "title": "Gérez votre SII, Aujourd'hui !",
    "subtitle": "Gérez votre SII, vos déclencheurs et votre mode de vie grâce à une application de suivi du SII conçue par des personnes souffrant du SII pour des personnes souffrant du SII.",
    "soon": "Bientôt sur iPhone et Android.",
    "getNotified": "Soyez Notifiés"
  }
}
</i18n>

<style lang="scss" scoped>
    @import '../assets/scss/variabls.scss';
    @import '../assets/scss/elements/hero-branding.scss';
    .hero-branding {
        // responsive
        @media #{$large-mobile}{
            height: 600px;
            padding-right: 125px;
        }
        @media #{$small-mobile}{
            height: 550px;
            padding-right: 30px;
        }
        @media #{$small-mobile}{
            padding-right: 0;
        }
    }
    .hero-content {
        @media #{$large-mobile}{
            width: 100%;
        }
    }
</style>
